import { useObserver } from 'mobx-react-lite'
import { createContext, FC, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react'
import { useApi } from 'service/useApi'
import { useAuth } from 'service/useAuth'

import { CustomerPreference } from './CustomerPreference'

export type CustomerPreferenceStore = {
  customerPreference: CustomerPreference | null
  setCustomerPreference: (customerPreference: CustomerPreference) => void
}

export const CustomerPreferenceContext = createContext<CustomerPreferenceStore | null>(null)

export const CustomerPreferenceContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return useObserver(() => {
    const { state } = useAuth()
    const customerId = state.customer?._id
    const { customers } = useApi()
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    const [customerPreference, setCustomerPreference] = useState<CustomerPreference>(null)

    useEffect(() => {
      async function load() {
        if (!customerId) {
          return
        }
        // @ts-expect-error TS(2345) FIXME: Argument of type 'CustomerPreference | null' is no... Remove this comment to see the full error message
        setCustomerPreference(await customers.getCustomerPreference(customerId))
      }

      load()
    }, [customerId])

    const store = useMemo(
      () => ({
        customerPreference,
        setCustomerPreference,
      }),
      [customerPreference]
    )

    return <CustomerPreferenceContext.Provider value={store}>{children}</CustomerPreferenceContext.Provider>
  })
}

export function useCustomerPreference() {
  const customerPreference = useContext(CustomerPreferenceContext)
  if (!customerPreference) {
    throw new Error('Must use useCustomerPreference within an CustomerPreferenceContext')
  }
  return customerPreference
}
